module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-diamond-fill-3825c0c7.svg";